import { Box, Flex, Link, Text } from '@chakra-ui/react';
import { Badge } from '@morressier/alembic';

export interface IRenderProfileData {
  countryCallingCode?: string;
  countryCode?: string;
  phoneNumber?: string;
  linkedinProfileUrl?: string;
}

export interface RenderProfileDataProps {
  label?: string;
  value: IRenderProfileData;
  badge: string;
}

const RenderProfileData = ({ label, value, badge }: RenderProfileDataProps) => {
  const { countryCallingCode, phoneNumber, linkedinProfileUrl } = value ?? {};

  return (
    <Box>
      {label && (
        <Text textStyle="headingItem" mb={2}>
          {label}{' '}
          <Badge
            size="context"
            variant={badge === 'Previous' ? 'neutral' : 'attention'}
          >
            {badge}
          </Badge>
        </Text>
      )}

      <Flex direction="column" gap={2}>
        {!phoneNumber && !linkedinProfileUrl && (
          <Text textStyle="textBody" color="GrayText">
            No data available
          </Text>
        )}
        {phoneNumber && (
          <Text>
            <Text textStyle={'textBody'}>Phone:</Text> +{countryCallingCode}
            {phoneNumber}
          </Text>
        )}

        {linkedinProfileUrl && (
          <Text>
            <Text textStyle={'textBody'}>LinkedIn:</Text>{' '}
            <Link href={linkedinProfileUrl} color="blue.500" isExternal>
              {linkedinProfileUrl}
            </Link>
          </Text>
        )}
      </Flex>
    </Box>
  );
};

export default RenderProfileData;
